import Loader from 'core/components/common/Loader'
import { ModalBody } from 'core/components/common/ModalBody'
import { ModalHeader } from 'core/components/common/ModalHeader'
import ModalWrapper from 'core/components/common/ModalWrapper'
import { TextDiff } from 'core/components/common/TextDiff'
import { IPrompt } from 'core/interfaces/Prompt'
import { IPromptHistory } from 'core/interfaces/PromptHistory'
import {
  RETRIEVE_CHOICE_PROMPT,
  RETRIEVE_CHOICE_PROMPT_AND_DOCUMENTS,
  useRetrievePrompt,
} from 'lauria/hooks/useRetrievePrompt'
// eslint-disable-next-line import/no-extraneous-dependencies -- présent dans dependencies (résolution ESLint)
import { Trans, useTranslation } from 'react-i18next'

export const RetrievePromptHistoryModal = ({
  open,
  setOpen,
  promptHistory,
  refetchPrompt,
  prompt,
}: {
  open: boolean
  setOpen: (open: boolean) => void
  promptHistory: IPromptHistory | null
  refetchPrompt: () => void
  prompt: IPrompt
}) => {
  const { t } = useTranslation()
  const { onSubmit, register, errors, hide, isLoading } = useRetrievePrompt(
    promptHistory,
    setOpen,
    open,
    refetchPrompt
  )

  if (isLoading) {
    return <Loader center />
  }
  return (
    <ModalWrapper
      classNames={{ modal: 'modal modal-retrieve-prompt-history' }}
      onClose={hide}
      open={open}
      showCloseIcon
      styles={{ overlay: { backgroundColor: 'transparent' } }}
    >
      <ModalHeader>
        <div className="flex items-center gap-x-[10px] dark:text-gray-1325">
          {t('prompts.historise.retrievePromptModal.title')}
        </div>
      </ModalHeader>
      <ModalBody className="flex flex-col px-[30px] mt-[20px]">
        <div className="mb-10px">
          {t('prompts.historise.retrievePromptModal.compare')}
        </div>
        <TextDiff
          oldTextTitle={t('prompts.historise.retrievePromptModal.oldPrompt')}
          newTextTitle={t('prompts.historise.retrievePromptModal.newPrompt')}
          oldText={prompt.prompt}
          newText={promptHistory?.promptHistorise ?? ''}
        />
        <div className="mt-[10px]">
          {t('prompts.historise.retrievePromptModal.text')}
        </div>
        <form
          className="flex flex-col gap-y-[10px] mt-[10px]"
          onSubmit={onSubmit}
        >
          <div className="flex flex-col gap-y-[10px]">
            <label className="flex items-center gap-x-2 cursor-pointer">
              <input
                type="radio"
                {...register.choice}
                value={RETRIEVE_CHOICE_PROMPT}
                className="cursor-pointer"
              />
              <Trans
                i18nKey="prompts.historise.retrievePromptModal.onlyPrompt"
                components={{ u: <u /> }}
              />
            </label>
            <label className="flex items-center gap-x-2 cursor-pointer">
              <input
                type="radio"
                {...register.choice}
                value={RETRIEVE_CHOICE_PROMPT_AND_DOCUMENTS}
                className="cursor-pointer"
              />
              <span>
                {t('prompts.historise.retrievePromptModal.allPrompt')}
              </span>
            </label>
            {errors.choice && (
              <p className="form-error">
                {t('prompts.historise.retrievePromptModal.selectOption')}
              </p>
            )}
          </div>
          <div className="flex flex-row items-center justify-end gap-x-[30px] mt-[20px] mb-[20px]">
            <button
              type="button"
              className="btn-submit cancel uppercase"
              onClick={hide}
            >
              {t('global.form.button.cancel')}
            </button>
            <button
              type="submit"
              className="btn-submit default w-fit uppercase"
            >
              {t('prompts.historise.retrievePromptModal.submit')}
            </button>
          </div>
        </form>
      </ModalBody>
    </ModalWrapper>
  )
}
